import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('intelligentOutboundCallStore', 'marketingSmsManagementStore')
@observer
class SearchResult extends Component {
  state = {
  }
  componentDidMount() {
  }
  handleDelete = (record) => {
    const {intelligentOutboundCallStore, marketingSmsManagementStore} = this.props
    const { generateID } = marketingSmsManagementStore
    intelligentOutboundCallStore.onDeleteOnePhoneAction(record?.id).then(res=> {
      if (res?.data?.code === 0) {
        intelligentOutboundCallStore.onStatisticsAction(generateID)
      }
    })
  }
  handlePageChange = (page, pageSize) => {
    const {intelligentOutboundCallStore} = this.props
    intelligentOutboundCallStore.onChangePhonePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {intelligentOutboundCallStore, t} = this.props
    const {pageNoPhone, pageSizePhone, itemCountPhone, phoneList} = intelligentOutboundCallStore
    const pagination = getPaginationConfig(pageNoPhone, pageSizePhone, itemCountPhone, this.handlePageChange)
    return (
      <>
        <Table className="searchResult" dataSource={toJS(phoneList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} style={{marginTop: 0, paddingTop: 0}}>
          <Table.Column title={t(`marketingManagement.phoneNumber`)} dataIndex="phoneNumber" key="phoneNumber" ellipsis={true} render={(text, record) => (
            <div style={record?.isValid === 1 ? {color: 'rgb(255, 51, 51)'} : {}}>
              {text}
            </div>
          )} />
          <Table.Column title={t(`marketingManagement.dataSource`)} dataIndex="dataSource" key="dataSource" ellipsis={true} render={(text, record) => (
            text === 'MANUAL' ? '手动输入' : text === 'FILE' ? '文件导入' : '资源池导入'
          )} />
          <Table.Column title={t(`marketingManagement.phoneDesc`)} dataIndex="dataStatus" key="dataStatus" ellipsis={true} render={(text, record) => (
            record?.dataStatus === 0 ? '无效' : '有效'
          )} />
          <Table.Column title={t(`marketingManagement.errorMsg`)} dataIndex="errorMsg" key="errorMsg" ellipsis={true} render={(text, record) => (
            record?.dataStatus === 0 ? record?.errorMsg : '-'
          )} />
          <Table.Column width={150} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              <Button type="link" onClick={() => this.handleDelete(record)}title={t(`general.delete`)}>{t(`general.delete`)}</Button>
            </>
          )} />
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
